module.exports = __webpack_public_path__ + "media/images/logos/ruta-valdepenas-16874ac67f692361c2ae2b3a59bc056e.png";